import { blue10, blue200, blue500, blue700, blue800, blueGray10, blueGray100, blueGray300, blueGray400, blueGray500, darkBlue10, darkBlue800, darkBlue900, gray100, gray400, gray50, gray900, green10, green300, green400, green800, purple10, purple300, purple400, purple600, red10, red200, red400, red700, white, yellow10, yellow300, yellow400, yellow800 } from "./colors";
import zIndex from "./zIndex";
import transition from "./transition";
import boxShadow from "./boxShadow";
import spacing from "./spacing";
import typography from "./typography";
import breakpoints from "./breakpoints";
export default {
  palette: {
    // deprecated
    title: darkBlue900,
    label: blueGray500,
    border: darkBlue10,
    description: blueGray500,
    placeholder: blueGray300,
    disabled: darkBlue10,
    disabledText: blueGray300,
    link: blue700,
    // texts
    text: {
      "default": blueGray500,
      dark: darkBlue900,
      secondary: blueGray400,
      placeholder: blueGray300,
      light: blueGray100,
      white: white,
      link: blue700,
      // deprecated
      primary: gray900,
      input: gray900
    },
    // backgrounds
    background: {
      system: gray100,
      secondary: darkBlue10,
      white: white
    },
    // system
    error: {
      "default": red400,
      text: red700,
      hover: red200,
      background: red10
    },
    alert: {
      "default": yellow400,
      text: yellow800,
      hover: yellow300,
      background: yellow10
    },
    success: {
      "default": green400,
      text: green800,
      hover: green300,
      background: green10
    },
    info: {
      "default": purple400,
      text: purple600,
      hover: purple300,
      background: purple10
    },
    primary: {
      "default": blue700,
      text: blue800,
      hover: blue500,
      light: blue200,
      background: blue10,
      backgroundLight: blueGray10,
      disabled: gray400
    },
    secondary: {
      "default": darkBlue900,
      light: darkBlue800,
      background: darkBlue10
    },
    action: {
      selected: gray50
    },
    // Deprecated - use primary or secondary
    brand: {
      primary: blue700,
      primaryHover: blue10,
      secondary: darkBlue900
    }
  },
  zIndex: zIndex,
  transition: transition,
  typography: typography,
  boxShadow: boxShadow,
  breakpoints: breakpoints,
  spacer: spacing(5)
};